<template>
    <div class="doc-item-unsupported">
        Tipo de item não tratado:
        <strong>{{ item.tpresposta || 'NÃO INFORMADO' }}</strong>
    </div>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
});
</script>

<style scoped>
.doc-item-unsupported {
    padding: 10px;
    border: 1px dashed #999;
    border-radius: 6px;
    background: #fafafa;
    font-size: 13px;
}
</style>